/**
 * Point d'entrée de l'application.
 * Aucun appel réseau applicatif : tout est servi depuis le domaine.
 * La feuille de style est liée depuis index.html, jamais importée ici.
 */

import './ui/md.js';
import './ui/app.js';
import { store } from './ui/store.js';

// Applique le thème mémorisé avant le premier rendu, pour éviter un
// clignotement lors du passage clair ↔ sombre.
store.setTheme(store.theme);

const racine = document.getElementById('app');
if (racine === null) {
  throw new Error('Élément #app introuvable dans index.html');
}
racine.innerHTML = '<app-root></app-root>';

/*
  Hors-ligne : une fois la page ouverte, le service worker conserve la
  coquille et les ressources. Le jour de l'élection, le scrutin peut se tenir
  sans aucune connexion — y compris si le réseau de l'établissement tombe.

  Enregistré en production seulement : en développement, il masquerait le
  rechargement à chaud et pourrait servir des fichiers périmés.
*/
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Un échec d'enregistrement ne doit jamais empêcher l'élection.
    });
  });
}
